import React, { useState, useEffect } from 'react'

interface MarqueeProps {
  text?: string
}

export const Marquee: React.FC<MarqueeProps> = ({ text }) => {
  const [offset, setOffset] = useState<number>(0)
  const [textWidth, setTextWidth] = useState<number>(0)
  const [containerWidth, setContainerWidth] = useState<number>(0)
  const [currentBreakpoint, setCurrentBreakpoint] = useState<string>('xs')
  const [windowWidth, setWindowWidth] = useState<number>(0)

  // Detect current breakpoint
  useEffect(() => {
    const updateBreakpoint = () => {
      const width = window.innerWidth
      setWindowWidth(width)
      if (width >= 1536) setCurrentBreakpoint('2xl')
      else if (width >= 1280) setCurrentBreakpoint('xl')
      else if (width >= 1024) setCurrentBreakpoint('lg')
      else if (width >= 768) setCurrentBreakpoint('md')
      else if (width >= 640) setCurrentBreakpoint('sm')
      else setCurrentBreakpoint('xs')
    }

    updateBreakpoint()
    window.addEventListener('resize', updateBreakpoint)
    return () => window.removeEventListener('resize', updateBreakpoint)
  }, [])

  useEffect(() => {
    // Get the width of the text and container divs
    const textElement = document.getElementById('marquee-text')
    const containerElement = document.getElementById('marquee-container')
    if (textElement && containerElement) {
      setTextWidth(textElement.offsetWidth)
      setContainerWidth(containerElement.offsetWidth)
    }
  }, [])

  useEffect(() => {
    // Set interval to move the marquee
    const intervalId = setInterval(() => {
      setOffset((offset) => (offset + 1) % (textWidth + containerWidth))
    }, 20)

    // Clear interval when component unmounts
    return () => clearInterval(intervalId)
  }, [textWidth, containerWidth])

  const animationDelay = containerWidth / 100 // Adjust this value to control the speed of the animation

  return (
    <div
      id="marquee-container"
      style={{
        height: '30px',
        background:
          'repeating-linear-gradient(45deg,#73ABE020,#73ABE020 10px,#FFFFFF20 10px,#FFFFFF20 20px)',
      }}
      className="w-full relative overflow-hidden whitespace-nowrap"
    >
      <div
        id="marquee-text-container"
        className="absolute"
        style={{
          left: `${offset}px`,
          animation: `marquee ${animationDelay}s linear infinite`,
          width: `${textWidth}px`,
        }}
      >
        <div id="marquee-text" className="text-brand font-bold">
          {text} • Current breakpoint: {currentBreakpoint} ({windowWidth}px)
        </div>
      </div>
    </div>
  )
}
